export const inputValidation = ({ name, value }) => {
  if (name === "customAmount") {
    if (value < 50) {
      return false;
    } else {
      return true;
    }
  } else if (name === "phone") {
    if (value.length < 8 || value.length > 25) {
      return false;
    } else {
      return true;
    }
  } else {
    return;
  }
};
